import type { DarkOffering } from "../../types";

export const darkOfferings: DarkOffering[] = [
  {
    id: 1,
    name: "Artistic Taste",
    description:
      "You have atrocious taste in fashion, food, and aesthetics. Your outfit, food choices, and décor preferences are an affront to sensibility.",
    effects: [],
  },
  {
    id: 2,
    name: "Cleanliness",
    description:
      "You are constantly filthy — mud and flies appear on you no matter how recently you cleaned yourself.",
    effects: [],
  },
  {
    id: 3,
    name: "Courage",
    description:
      "You are terrified of one of the following (choose one): animals, blood, darkness, fire, ghosts, or tight spaces.",
    effects: [],
  },
  {
    id: 4,
    name: "Dishonesty",
    description:
      "You cannot lie or mislead anyone, even through omission. You must answer questions truthfully and completely.",
    effects: [],
  },
  {
    id: 5,
    name: "Focus",
    description:
      "You are effortlessly distracted by new information. Any interesting piece of gossip, rumour, or news will derail your attention immediately.",
    effects: [],
  },
  {
    id: 6,
    name: "Humanity",
    description:
      "You have animalistic traits (choose one: cat, fox, bird, etc.). These manifest visibly in your mannerisms and appearance.",
    effects: [],
  },
  {
    id: 7,
    name: "Heart",
    description:
      "You are unmoved by heartbreaking events. Tragedy, loss, and suffering leave you cold. Optionally, your heart is literally missing from your chest.",
    effects: [],
  },
  {
    id: 8,
    name: "Independence",
    description:
      "You are loath to do anything alone and constantly seek approval. You find independent decision-making uncomfortable and anxiety-inducing.",
    effects: [],
  },
  {
    id: 9,
    name: "Insight",
    description:
      "You cannot see the true motives of others. You believe everything that seems reasonable and take everything literally.",
    effects: [],
  },
  {
    id: 10,
    name: "Joy",
    description:
      "You cannot understand humour. You are stony-faced and serious at all times, unable to comprehend why things are funny.",
    effects: [],
  },
  {
    id: 11,
    name: "Light Tolerance",
    description:
      "You cannot stand sunlight. You lose 1 HP per minute in direct sunlight.",
    effects: [],
  },
  {
    id: 12,
    name: "Literacy",
    description:
      "You cannot read or write. The written word is completely incomprehensible to you.",
    effects: [],
  },
  {
    id: 13,
    name: "Moderation",
    description:
      "You are obsessed with a worthless collectible (choose one: snowglobes, rubber ducks, funko pops, etc.). You must acquire them whenever possible.",
    effects: [],
  },
  {
    id: 14,
    name: "Optimism",
    description:
      "You see the worst possible outcome of everything and overprepare for catastrophe. Every situation is approached with doom-laden pessimism.",
    effects: [],
  },
  {
    id: 15,
    name: "Patience",
    description:
      'You find waiting excruciating. You are constantly asking "Are we there yet?" and cannot tolerate delays or slow progress.',
    effects: [],
  },
  {
    id: 16,
    name: "Peace of Mind",
    description:
      "Everything is a conspiracy to you. You read hidden meaning into everything and trust no simple explanation.",
    effects: [],
  },
  {
    id: 17,
    name: "Pound of Flesh",
    description:
      "You are missing a hand, foot, eye, or similar body part. This must be represented physically in your costume.",
    effects: [],
  },
  {
    id: 18,
    name: "Self Preservation",
    description:
      "You have no sense of danger or pain and always take risks. You must roleplay being reckless and unaware of physical peril.",
    effects: [],
  },
  {
    id: 19,
    name: "Wealth",
    description:
      "You have traded away your worldly possessions. Your Wealth Level goes down by 1.",
    effects: [{ type: "wealthLevel", value: -1 }],
  },
  {
    id: 20,
    name: "Youth",
    description:
      "You have traded away years of your life. You outwardly appear venerable and ancient, far older than your true age.",
    effects: [],
  },
];
